"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECOGNIZE_PASSPORT_UI = exports.BOOKING_PROCESS_UI = exports.BOOKING_OFFER_BY_OPERATOR_UI = void 0;
var BOOKING_OFFER_BY_OPERATOR_UI = exports.BOOKING_OFFER_BY_OPERATOR_UI = 'BOOKING_OFFER_BY_OPERATOR';
var RECOGNIZE_PASSPORT_UI = exports.RECOGNIZE_PASSPORT_UI = 'RECOGNIZE_PASSPORT_UI';
var BOOKING_PROCESS_UI = exports.BOOKING_PROCESS_UI = 'BOOKING_PROCESS_UI';